import CategoryBadge from '@boComponents/CategoryBadge';
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import Button from '@sharedComponents/Button';
import FlexBox from '@sharedComponents/FlexBox';
import SkeletonIconButton from '@sharedComponents/SkeletonIconButton';
import Tag from '@sharedComponents/Tag';
import Typography from '@sharedComponents/Typography';

import { getClientTypeLabel, getCsmDisplayName } from '../../helpers';

import rowStyle from '@sharedComponents/Row/style.module.css';

const EMPTY = '—';

// Client name with, on a second line, the platform count when the client owns several platforms
// (same two-line layout as the tests / contacts cells of the evaluation follow-up).
const ClientNameCell = ({ client, t }) => {
    const platformCount = client.platformCount ?? 0;
    return (
        <FlexBox flexDirection="column" gap="xxs">
            <Typography fontWeight="medium">{client.name}</Typography>
            {platformCount > 1 && (
                <Typography fontSize="s" color="neutral-tertiary">
                    {t('{{count}} platform(s)', { count: platformCount })}
                </Typography>
            )}
        </FlexBox>
    );
};

// Columns of the "By client" tab: one row per client.
export const getClientColumns = (t, { onView = () => {} } = {}) => [
    {
        key: 'name',
        label: t('Name'),
        tdClassName: rowStyle.td,
        render: (client) => <ClientNameCell client={client} t={t} />,
    },
    { key: 'reference', label: t('Reference'), tdClassName: rowStyle.td, render: (client) => client.reference ?? EMPTY },
    {
        key: 'category',
        label: t('Category'),
        tdClassName: rowStyle.td,
        render: (client) => <CategoryBadge category={client.category} />,
    },
    { key: 'csm', label: t('CSM'), tdClassName: rowStyle.td, render: (client) => getCsmDisplayName(client.csm) ?? EMPTY },
    {
        key: 'clientType',
        label: t('Client type'),
        tdClassName: rowStyle.td,
        render: (client) => getClientTypeLabel(t, client.clientType) ?? EMPTY,
    },
    {
        key: 'status',
        label: t('Status'),
        tdClassName: rowStyle.td,
        render: (client) => <Tag color={client.active ? 'success' : 'disabled'}>{client.active ? t('Active') : t('Inactive')}</Tag>,
    },
    {
        key: 'actions',
        ariaLabel: t('Actions'),
        tdClassName: rowStyle.tdActions,
        pinned: true,
        // The button sets the height of a row.
        skeleton: <SkeletonIconButton />,
        render: (client) => <Button ghost icon={faEye} action={() => onView(client.uuid)} title={t('View client')} />,
    },
];
